export default __webpack_public_path__ + "static/media/26.a9c6216f.jpg";